import { BoilerConsumptionV5 } from './Aol/BoilerConsumptionV5';
import { Consumption } from './Aol/Consumption';
import { DirectionEnum, NoonReportTypeEnum, SeaStateEnum, WindForceEnum } from './AolEnums';
import { CargoTankTemperature } from './CargoTankTemperature';
import { CargoTemperature } from './CargoTemperature';
import { EngineData } from './EngineData';
import { EvaporatorData } from './EvaporatorData';
import { FuelRobData } from './FuelRobData';
import { Heater } from './Heater';
import { MrvData } from './MrvData';
import { NitrogenGeneratorData } from './NitrogenGeneratorData';
import { NoonReportDateTime } from './NoonReportDateTime';
import { NoonReportSectionData } from './NoonReportSectionData';
import { Pump } from './Pump';

export class ValidatedNoonReport {
    metadata: NoonReportMetadata;
    generalSection: NoonReportGeneralSection;
    activitiesSection?: NoonReportActivitiesSection;
    bridgeSection?: NoonReportBridgeSection;
    weatherSection?: NoonReportWeatherSection;
    tankCleaningSection?: NoonReportTankCleaningSection;
    cargoHeatingSection?: NoonReportCargoHeatingSection;
    enginesSection?: NoonReportEnginesSection;
    freshWaterSection?: NoonReportFreshWaterSection;
    powerpacksSection?: NoonReportPowerpacksSection;
    inertGasProductionSection?: NoonReportInertGasProductionSection;
    mrvSection?: NoonReportMrvSection;
    fuelRobSection?: NoonReportFuelRobSection;
    commentsSection?: NoonReportCommentsSection;

    hasOfflineData?: boolean | null;

    constructor(
        metadata: NoonReportMetadata,
        generalSection: NoonReportGeneralSection,
        activitiesSection?: NoonReportActivitiesSection,
        bridgeSection?: NoonReportBridgeSection,
        weatherSection?: NoonReportWeatherSection,
        tankCleaningSection?: NoonReportTankCleaningSection,
        cargoHeatingSection?: NoonReportCargoHeatingSection,
        enginesSection?: NoonReportEnginesSection,
        freshWaterSection?: NoonReportFreshWaterSection,
        powerpacksSection?: NoonReportPowerpacksSection,
        inertGasProductionSection?: NoonReportInertGasProductionSection,
        mrvSection?: NoonReportMrvSection,
        fuelRobSection?: NoonReportFuelRobSection,
        commentsSection?: NoonReportCommentsSection
    ) {
        this.metadata = metadata;
        this.generalSection = generalSection;
        this.activitiesSection = activitiesSection;
        this.bridgeSection = bridgeSection;
        this.weatherSection = weatherSection;
        this.tankCleaningSection = tankCleaningSection;
        this.cargoHeatingSection = cargoHeatingSection;
        this.enginesSection = enginesSection;
        this.freshWaterSection = freshWaterSection;
        this.powerpacksSection = powerpacksSection;
        this.inertGasProductionSection = inertGasProductionSection;
        this.mrvSection = mrvSection;
        this.fuelRobSection = fuelRobSection;
        this.commentsSection = commentsSection;
    }
}

export class NoonReportMetadata {
    noonReportId: number;
    noonReportGuid?: string;
    legId: number;
    noonReportType: NoonReportTypeEnum;
    lastUpdatedUtc: Date;
    lastUpdatedBy: string;
    aolCompletedUtc: Date;
    aolCompletedBy: string;
    aolApprovedUtc: Date;
    aolApprovedBy: string;
    indexInDay: number;
    voyageNumber: number;
    previousPortCallId: number;
    lastPortVisitId: number;
    numberOfReportsInDay: number;
    imosPortCallId: number;
    aolVersion: number;
    isAolComplete: boolean;
    isAolApproved: boolean;
    simpleModeAol: boolean;
    imoNumber: number;
    constructor(
        noonReportId: number,
        legId: number,
        noonReportType: NoonReportTypeEnum,
        lastUpdatedUtc: Date,
        lastUpdatedBy: string,
        aolCompletedUtc: Date,
        aolCompletedBy: string,
        aolApprovedUtc: Date,
        aolApprovedBy: string,
        indexInDay: number,
        voyageNumber: number,
        previousPortCallId: number,
        lastPortVisitId: number,
        numberOfReportsInDay: number,
        imosPortCallId: number,
        aolVersion: number,
        isAolComplete: boolean,
        isAolApproved: boolean,
        simpleModeAol: boolean
    ) {
        this.noonReportId = +noonReportId;
        this.legId = +legId;
        this.noonReportType = +noonReportType;
        this.lastUpdatedUtc = lastUpdatedUtc;
        this.lastUpdatedBy = lastUpdatedBy;
        this.aolCompletedUtc = aolCompletedUtc;
        this.aolCompletedBy = aolCompletedBy;
        this.aolApprovedUtc = aolApprovedUtc;
        this.aolApprovedBy = aolApprovedBy;
        this.indexInDay = +indexInDay;
        this.voyageNumber = +voyageNumber;
        this.previousPortCallId = +previousPortCallId;
        this.lastPortVisitId = +lastPortVisitId;
        this.numberOfReportsInDay = +numberOfReportsInDay;
        this.imosPortCallId = +imosPortCallId;
        this.aolVersion = +aolVersion;
        this.isAolComplete = isAolComplete;
        this.isAolApproved = isAolApproved;
        this.simpleModeAol = simpleModeAol;
    }
}

export class NoonReportCommentsSection {
    sectionData: NoonReportSectionData;
    comments: string;
    constructor(sectionData: NoonReportSectionData, comments: string) {
        this.sectionData = sectionData;
        this.comments = comments;
    }
}

export class NoonReportMrvSection {
    sectionData?: NoonReportSectionData;
    mrvData: MrvData[];
    constructor(mrvData: MrvData[], sectionData?: NoonReportSectionData) {
        this.sectionData = sectionData;
        this.mrvData = mrvData;
    }
}

export class NoonReportFuelRobSection {
    sectionData?: NoonReportSectionData;
    fuelRobData: FuelRobData[];
    constructor(fuelRobData: FuelRobData[], sectionData?: NoonReportSectionData) {
        this.sectionData = sectionData;
        this.fuelRobData = fuelRobData;
    }
}

export class NoonReportInertGasProductionSection {
    sectionData: NoonReportSectionData;
    nitrogenGenerators: NitrogenGeneratorData[];
    inertGasGeneratorConsumptionMgo?: number;
    consumption?: Consumption[];

    constructor(
        sectionData: NoonReportSectionData,
        nitrogenGenerators: NitrogenGeneratorData[],
        inertGasGeneratorConsumptionMgo?: number,
        consumption?: Consumption[]
    ) {
        this.sectionData = sectionData;
        this.nitrogenGenerators = nitrogenGenerators;
        this.inertGasGeneratorConsumptionMgo = inertGasGeneratorConsumptionMgo;
        this.consumption = consumption;
    }
}

export class NoonReportPowerpacksSection {
    sectionData: NoonReportSectionData;
    dieselGasoilDrivenPowerpacks: EngineData[];
    electricalDrivenPowerPacks: EngineData[];
    consumption?: Consumption[];

    constructor(
        sectionData: NoonReportSectionData,
        dieselGasoilDrivenPowerpacks: EngineData[],
        electricalDrivenPowerPacks: EngineData[],
        consumption?: Consumption[]
    ) {
        this.sectionData = sectionData;
        this.dieselGasoilDrivenPowerpacks = dieselGasoilDrivenPowerpacks;
        this.electricalDrivenPowerPacks = electricalDrivenPowerPacks;
        this.consumption = consumption;
    }
}

export class NoonReportFreshWaterSection {
    sectionData: NoonReportSectionData;
    freshWaterDeliveredFromShore: number;
    freshWaterProduction: number;
    freshWaterEvaporatorData: EvaporatorData[];
    freshWaterProductionByReversedOsmosis: number;
    freshWaterUsedForTankCleaning: number;
    freshWaterUsedForDomesticUse: number;
    freshWaterProducedBySteam: number;
    constructor(
        sectionData: NoonReportSectionData,
        freshWaterDeliveredFromShore: number,
        freshWaterProduction: number,
        freshWaterEvaporatorData: EvaporatorData[],
        freshWaterProductionByReversedOsmosis: number,
        freshWaterUsedForTankCleaning: number,
        freshWaterUsedForDomesticUse: number,
        freshWaterProducedBySteam: number
    ) {
        this.sectionData = sectionData;
        this.freshWaterDeliveredFromShore = freshWaterDeliveredFromShore;
        this.freshWaterProduction = freshWaterProduction;
        this.freshWaterEvaporatorData = freshWaterEvaporatorData;
        this.freshWaterProductionByReversedOsmosis = freshWaterProductionByReversedOsmosis;
        this.freshWaterUsedForTankCleaning = freshWaterUsedForTankCleaning;
        this.freshWaterUsedForDomesticUse = freshWaterUsedForDomesticUse;
        this.freshWaterProducedBySteam = freshWaterProducedBySteam;
    }
}

export class NoonReportEnginesSection {
    sectionData: NoonReportSectionData;
    mainEnginesData: EngineData;
    auxiliaryEnginesData: EngineData[];
    auxiliaryEnginesConsumptionHfo: number;
    auxiliaryEnginesConsumptionMgo: number;
    shaftGeneratorData: EngineData;
    boilersData: EngineData[];
    boilersConsumptionHfo: number;
    boilersConsumptionMgo: number;
    boilersConsumptionForEngineRoomAndAccommodation: number;
    boilersConsumptionForTankCleaning: number;
    boilersConsumptionForCargoHeating: number;
    boilersConsumptionForFreshWaterProduction: number;
    boilersConsumptionForOther: number;
    boilersConsumptionForEngineRoomAndAccommodationMgo: number;
    boilersConsumptionForTankCleaningMgo: number;
    boilersConsumptionForCargoHeatingMgo: number;
    boilersConsumptionForFreshWaterProductionMgo: number;
    boilersConsumptionForOtherMgo: number;
    boilersConsumptionForOtherText: string;
    economizerRunningHours: number;
    economizerDateOfLastCleaning: Date;
    isEconomizerSootBlowingEquipmentInOperations: boolean;
    isSurplusSteamAvailable?: boolean;
    isSurplusSteamUsedForFreshWaterProduction?: boolean;
    shorePowerRunningHours?: number;
    isShorePowerConnected?: boolean;
    shorePowerKwhReceived?: number;
    incineratorConsumptionMgo?: number;
    arePumpsAndFansSwitchedOff?: boolean;
    pumpsAndFansNotSwitchedOffReason: string;
    totalBoilerConsumptionDetails: number;
    consumption?: Consumption[];
    boilerConsumptionV5?: BoilerConsumptionV5[];

    constructor(
        sectionData: NoonReportSectionData,
        mainEnginesData: EngineData,
        auxiliaryEnginesData: EngineData[],
        auxiliaryEnginesConsumptionHfo: number,
        auxiliaryEnginesConsumptionMgo: number,
        shaftGeneratorData: EngineData,
        boilersData: EngineData[],
        boilersConsumptionHfo: number,
        boilersConsumptionMgo: number,
        boilersConsumptionForEngineRoomAndAccommodation: number,
        boilersConsumptionForTankCleaning: number,
        boilersConsumptionForCargoHeating: number,
        boilersConsumptionForFreshWaterProduction: number,
        boilersConsumptionForOther: number,
        boilersConsumptionForEngineRoomAndAccommodationMgo: number,
        boilersConsumptionForTankCleaningMgo: number,
        boilersConsumptionForCargoHeatingMgo: number,
        boilersConsumptionForFreshWaterProductionMgo: number,
        boilersConsumptionForOtherMgo: number,
        boilersConsumptionForOtherText: string,
        economizerRunningHours: number,
        economizerDateOfLastCleaning: Date,
        isEconomizerSootBlowingEquipmentInOperations: boolean,
        pumpsAndFansNotSwitchedOffReason: string,
        isSurplusSteamAvailable?: boolean,
        isSurplusSteamUsedForFreshWaterProduction?: boolean,
        shorePowerRunningHours?: number,
        isShorePowerConnected?: boolean,
        shorePowerKwhReceived?: number,
        incineratorConsumptionMgo?: number,
        arePumpsAndFansSwitchedOff?: boolean,
        consumption?: Consumption[],
        boilerConsumptionV5?: BoilerConsumptionV5[]
    ) {
        this.sectionData = sectionData;
        this.mainEnginesData = mainEnginesData;
        this.auxiliaryEnginesData = auxiliaryEnginesData;
        this.auxiliaryEnginesConsumptionHfo = auxiliaryEnginesConsumptionHfo;
        this.auxiliaryEnginesConsumptionMgo = auxiliaryEnginesConsumptionMgo;
        this.shaftGeneratorData = shaftGeneratorData;
        this.boilersData = boilersData;
        this.boilersConsumptionHfo = boilersConsumptionHfo;
        this.boilersConsumptionMgo = boilersConsumptionMgo;
        this.boilersConsumptionForEngineRoomAndAccommodation = boilersConsumptionForEngineRoomAndAccommodation;
        this.boilersConsumptionForTankCleaning = boilersConsumptionForTankCleaning;
        this.boilersConsumptionForCargoHeating = boilersConsumptionForCargoHeating;
        this.boilersConsumptionForFreshWaterProduction = boilersConsumptionForFreshWaterProduction;
        this.boilersConsumptionForOther = boilersConsumptionForOther;
        this.boilersConsumptionForEngineRoomAndAccommodationMgo = boilersConsumptionForEngineRoomAndAccommodationMgo;
        this.boilersConsumptionForTankCleaningMgo = boilersConsumptionForTankCleaningMgo;
        this.boilersConsumptionForCargoHeatingMgo = boilersConsumptionForCargoHeatingMgo;
        this.boilersConsumptionForFreshWaterProductionMgo = boilersConsumptionForFreshWaterProductionMgo;
        this.boilersConsumptionForOtherMgo = boilersConsumptionForOtherMgo;
        this.boilersConsumptionForOtherText = boilersConsumptionForOtherText;
        this.economizerRunningHours = economizerRunningHours;
        this.economizerDateOfLastCleaning = economizerDateOfLastCleaning;
        this.isEconomizerSootBlowingEquipmentInOperations = isEconomizerSootBlowingEquipmentInOperations;
        this.isSurplusSteamAvailable = isSurplusSteamAvailable;
        this.isSurplusSteamUsedForFreshWaterProduction = isSurplusSteamUsedForFreshWaterProduction;
        this.shorePowerRunningHours = shorePowerRunningHours;
        this.isShorePowerConnected = isShorePowerConnected;
        this.shorePowerKwhReceived = shorePowerKwhReceived;
        this.incineratorConsumptionMgo = incineratorConsumptionMgo;
        this.arePumpsAndFansSwitchedOff = arePumpsAndFansSwitchedOff;
        this.pumpsAndFansNotSwitchedOffReason = pumpsAndFansNotSwitchedOffReason;
        this.totalBoilerConsumptionDetails =
            boilersConsumptionForEngineRoomAndAccommodation +
            boilersConsumptionForTankCleaning +
            boilersConsumptionForCargoHeating +
            boilersConsumptionForFreshWaterProduction +
            boilersConsumptionForOther +
            boilersConsumptionForEngineRoomAndAccommodationMgo +
            boilersConsumptionForTankCleaningMgo +
            boilersConsumptionForCargoHeatingMgo +
            boilersConsumptionForFreshWaterProductionMgo +
            boilersConsumptionForOtherMgo;
        this.consumption = consumption;
        this.boilerConsumptionV5 = boilerConsumptionV5;
    }
}

export class NoonReportCargoHeatingSection {
    sectionData: NoonReportSectionData;
    directHeating: boolean;
    heatingFromAdjacentTanks: boolean;
    indirectHeating: boolean;
    cargoCirculatingHeating: boolean;
    hotWaterCargoHeaters: Heater[];
    cargoTemperatures: CargoTemperature[];
    cargoTankTemperatures: CargoTankTemperature[];
    circulatingPumpsForCargoHeating: Pump[];

    constructor(
        sectionData: NoonReportSectionData,
        directHeating: boolean,
        heatingFromAdjacentTanks: boolean,
        indirectHeating: boolean,
        cargoCirculatingHeating: boolean,
        hotWaterCargoHeaters: Heater[],
        cargoTemperatures: CargoTemperature[],
        cargoTankTemperatures: CargoTankTemperature[],
        circulatingPumpsForCargoHeating: Pump[]
    ) {
        this.sectionData = sectionData;
        this.directHeating = directHeating;
        this.heatingFromAdjacentTanks = heatingFromAdjacentTanks;
        this.indirectHeating = indirectHeating;
        this.cargoCirculatingHeating = cargoCirculatingHeating;
        this.hotWaterCargoHeaters = hotWaterCargoHeaters;
        this.cargoTemperatures = cargoTemperatures;
        this.cargoTankTemperatures = cargoTankTemperatures;
        this.circulatingPumpsForCargoHeating = circulatingPumpsForCargoHeating;
    }
}
export class NoonReportTankCleaningSection {
    sectionData: NoonReportSectionData;
    tankCleaningOperationSinceLastReport?: boolean;
    tankCleaningDuration?: number;
    tankCleanerHeatersHoursWithHotWater?: number;
    tankCleanerHeatersHoursWithColdWater?: number;
    tankCleaningPumpFreshWaterRunningHours: number;
    tankCleaningPumpSeaWaterRunningHours: number;

    constructor(
        sectionData: NoonReportSectionData,
        tankCleaningPumpFreshWaterRunningHours: number,
        tankCleaningPumpSeaWaterRunningHours: number,
        tankCleaningOperationSinceLastReport?: boolean,
        tankCleaningDuration?: number,
        tankCleanerHeatersHoursWithHotWater?: number,
        tankCleanerHeatersHoursWithColdWater?: number
    ) {
        this.sectionData = sectionData;
        this.tankCleaningOperationSinceLastReport = tankCleaningOperationSinceLastReport;
        this.tankCleaningDuration = tankCleaningDuration;
        this.tankCleanerHeatersHoursWithHotWater = tankCleanerHeatersHoursWithHotWater;
        this.tankCleanerHeatersHoursWithColdWater = tankCleanerHeatersHoursWithColdWater;
        this.tankCleaningPumpFreshWaterRunningHours = tankCleaningPumpFreshWaterRunningHours;
        this.tankCleaningPumpSeaWaterRunningHours = tankCleaningPumpSeaWaterRunningHours;
    }
}

export class NoonReportWeatherSection {
    sectionData: NoonReportSectionData;
    seaDirection?: DirectionEnum;
    windDirection?: DirectionEnum;
    windForce?: WindForceEnum;
    badWeatherHours: number;
    airTemperature?: number;
    seaTemperature?: number;
    currentDirection?: DirectionEnum;
    currentForce: number;
    waveHeight: number;
    seaState?: SeaStateEnum;

    constructor(
        sectionData: NoonReportSectionData,
        badWeatherHours: number,
        currentForce: number,
        waveHeight: number,
        seaDirection?: DirectionEnum,
        windDirection?: DirectionEnum,
        windForce?: WindForceEnum,
        airTemperature?: number,
        seaTemperature?: number,
        currentDirection?: DirectionEnum,
        seaState?: SeaStateEnum
    ) {
        this.sectionData = sectionData;
        this.seaDirection = seaDirection;
        this.windDirection = windDirection;
        this.windForce = windForce;
        this.badWeatherHours = badWeatherHours;
        this.airTemperature = airTemperature;
        this.seaTemperature = seaTemperature;
        this.currentDirection = currentDirection;
        this.currentForce = currentForce;
        this.waveHeight = waveHeight;
        this.seaState = seaState;
    }
}

export class NoonReportBridgeSection {
    sectionData: NoonReportSectionData;
    loggedSpeed: number;
    loggedDistance: number;
    observedSpeed: number;
    observedDistance: number;
    ecaZoneHours: number;
    forwardDraft: number;
    aftDraft: number;
    navtorDistance: number;
    isNavtorDistanceValid: boolean;
    constructor(
        sectionData: NoonReportSectionData,
        loggedSpeed: number,
        loggedDistance: number,
        observedSpeed: number,
        observedDistance: number,
        ecaZoneHours: number,
        forwardDraft: number,
        aftDraft: number,
        navtorDistance: number,
        isNavtorDistanceValid: boolean
    ) {
        this.sectionData = sectionData;
        this.loggedSpeed = loggedSpeed;
        this.loggedDistance = loggedDistance;
        this.observedSpeed = observedSpeed;
        this.observedDistance = observedDistance;
        this.ecaZoneHours = ecaZoneHours;
        this.forwardDraft = forwardDraft;
        this.aftDraft = aftDraft;
        this.navtorDistance = navtorDistance;
        this.isNavtorDistanceValid = isNavtorDistanceValid;
    }
}

export class NoonReportActivitiesSection {
    sectionData: NoonReportSectionData;
    dryDockingPortActivityHours: number;
    offHirePortActivityHours?: number;
    loadingPortActivityHours: number;
    unloadingPortActivityHours: number;
    shiftingAndMooringPortActivityHours: number;
    idlePortActivityHours: number;
    anchorPortActivityHours: number;
    steamingForTankCleaningPortActivityHours: number;
    canalTransitPortActivityHours: number;

    offHireHours: number;

    awaitingOrderOrDriftingHours: number;
    speedOrderByOperatorsHours: number;
    standardActivitiesAtSeaHours: number;
    otherExclusionsHours: number;

    operationalTargetSpeedHours: number;
    operationalTargetConsumptionHours: number;
    operationalNonTargetHours: number;
    operationalAwaitingOrdersOrDriftingHours: number;
    operationalTankPreparationHours: number;

    navigationalEcaZoneHours: number;
    navigationalCasualtyAndSarHours: number;
    navigationalHighRiskAreaHours: number;
    navigationalPilotManeuveringHours: number;
    navigationalRiverPortManeuveringHours: number;
    navigationalSafetyManeuveringHours: number;
    navigationalStormShelteringHours: number;
    navigationalTrafficManeuveringHours: number;
    navigationalCasualtyAndSarDrillHours: number;

    technicalAuxiliarySystemFailureHours: number;
    technicalFuelQualityIssueHours: number;
    technicalPropulsionSystemFailureHours: number;
    technicalOtherTechnicalIssueHours: number;

    unscheduledStoppagesHours: number;
    speedOrderHours: number;
    constructor(
        sectionData: NoonReportSectionData,
        dryDockingPortActivityHours: number,
        loadingPortActivityHours: number,
        unloadingPortActivityHours: number,
        shiftingAndMooringPortActivityHours: number,
        idlePortActivityHours: number,
        anchorPortActivityHours: number,
        steamingForTankCleaningPortActivityHours: number,
        canalTransitPortActivityHours: number,
        offHireHours: number,
        awaitingOrderOrDriftingHours: number,
        speedOrderByOperatorsHours: number,
        standardActivitiesAtSeaHours: number,
        otherExclusionsHours: number,
        operationalTargetSpeedHours: number,
        operationalTargetConsumptionHours: number,
        operationalNonTargetHours: number,
        operationalAwaitingOrdersOrDriftingHours: number,
        operationalTankPreparationHours: number,
        navigationalEcaZoneHours: number,
        navigationalCasualtyAndSarHours: number,
        navigationalHighRiskAreaHours: number,
        navigationalPilotManeuveringHours: number,
        navigationalRiverPortManeuveringHours: number,
        navigationalSafetyManeuveringHours: number,
        navigationalStormShelteringHours: number,
        navigationalTrafficManeuveringHours: number,
        navigationalCasualtyAndSarDrillHours: number,
        technicalAuxiliarySystemFailureHours: number,
        technicalFuelQualityIssueHours: number,
        technicalPropulsionSystemFailureHours: number,
        technicalOtherTechnicalIssueHours: number,
        unscheduledStoppagesHours: number,
        speedOrderHours: number,
        offHirePortActivityHours?: number
    ) {
        this.sectionData = sectionData;
        this.dryDockingPortActivityHours = dryDockingPortActivityHours;
        this.offHirePortActivityHours = offHirePortActivityHours;
        this.loadingPortActivityHours = loadingPortActivityHours;
        this.unloadingPortActivityHours = unloadingPortActivityHours;
        this.shiftingAndMooringPortActivityHours = shiftingAndMooringPortActivityHours;
        this.idlePortActivityHours = idlePortActivityHours;
        this.anchorPortActivityHours = anchorPortActivityHours;
        this.steamingForTankCleaningPortActivityHours = steamingForTankCleaningPortActivityHours;
        this.canalTransitPortActivityHours = canalTransitPortActivityHours;
        this.offHireHours = offHireHours;
        this.awaitingOrderOrDriftingHours = awaitingOrderOrDriftingHours;
        this.standardActivitiesAtSeaHours = standardActivitiesAtSeaHours;
        this.otherExclusionsHours = otherExclusionsHours;
        this.speedOrderByOperatorsHours = speedOrderByOperatorsHours;

        this.operationalTargetSpeedHours = operationalTargetSpeedHours;
        this.operationalTargetConsumptionHours = operationalTargetConsumptionHours;
        this.operationalNonTargetHours = operationalNonTargetHours;
        this.operationalAwaitingOrdersOrDriftingHours = operationalAwaitingOrdersOrDriftingHours;
        this.operationalTankPreparationHours = operationalTankPreparationHours;

        this.navigationalEcaZoneHours = navigationalEcaZoneHours;
        this.navigationalCasualtyAndSarHours = navigationalCasualtyAndSarHours;
        this.navigationalHighRiskAreaHours = navigationalHighRiskAreaHours;
        this.navigationalPilotManeuveringHours = navigationalPilotManeuveringHours;
        this.navigationalRiverPortManeuveringHours = navigationalRiverPortManeuveringHours;
        this.navigationalSafetyManeuveringHours = navigationalSafetyManeuveringHours;
        this.navigationalStormShelteringHours = navigationalStormShelteringHours;
        this.navigationalTrafficManeuveringHours = navigationalTrafficManeuveringHours;
        this.navigationalCasualtyAndSarDrillHours = navigationalCasualtyAndSarDrillHours;

        this.technicalAuxiliarySystemFailureHours = technicalAuxiliarySystemFailureHours;
        this.technicalFuelQualityIssueHours = technicalFuelQualityIssueHours;
        this.technicalPropulsionSystemFailureHours = technicalPropulsionSystemFailureHours;
        this.technicalOtherTechnicalIssueHours = technicalOtherTechnicalIssueHours;

        this.unscheduledStoppagesHours = unscheduledStoppagesHours;
        this.speedOrderHours = speedOrderHours;
    }
}

export class NoonReportGeneralSection {
    sectionData: NoonReportSectionData;
    hours: number;
    idlOffsetHours: number;
    manualOffsetHours: number;
    noonReportDateTime: NoonReportDateTime;
    cargoOnBoard: number;
    ballast: number;
    hoursWithOffset: number;

    constructor(
        sectionData: NoonReportSectionData,
        hours: number,
        idlOffsetHours: number,
        manualOffsetHours: number,
        noonReportDateTime: NoonReportDateTime,
        cargoOnBoard: number,
        ballast: number
    ) {
        this.sectionData = sectionData;
        this.hours = hours;
        this.idlOffsetHours = idlOffsetHours;
        this.manualOffsetHours = manualOffsetHours;
        this.noonReportDateTime = noonReportDateTime;
        this.cargoOnBoard = cargoOnBoard;
        this.ballast = ballast;
        this.hoursWithOffset = +hours + +idlOffsetHours + +manualOffsetHours;
    }
}

export class NoonReportSection {
    sectionData: NoonReportSectionData;
    constructor(sectionData: NoonReportSectionData) {
        this.sectionData = sectionData;
    }
}
